export enum ReportType {
    ReportSection = 0,
    AwardedFinalEstimates = 1,
    ChangeOrders = 2,
    SalesProjects = 3,
    ServiceModules = 4,
    ServiceTerms = 5,
    ServiceCosts = 6,
    PointListSystems = 7,
    PointListSystemsLabor = 8,
    CompetingBidders = 9,
    ServiceCategories = 10,
    ServiceSubcategories = 11,
    ServiceModuleSubcontractors = 12,
    ServiceModuleExpenses = 13,
    ServiceModuleCustom = 14,
    ServiceModuleLabor = 15,
    ServiceModuleMaterial = 16,
    ProjectModules = 17,
    ProjectModuleSubcontractors = 18,
    ProjectModuleExpenses = 19,
    ProjectModuleCustoms = 20,
    ProjectModuleLabors = 21,
    ProjectModuleMaterials = 22,
    SalesLeads = 23,
    EstimateBid = 24,
    EstimateAwarded = 25,
    Opportunities = 26,
    Buildings = 27,
    Companies = 28,
    Accounts = 29,
    ProjectModuleMaterialGroup = 30,
    ServiceModuleMaterialGroup = 31
}
